var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgInvoiceSelected(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 19,
    viewBox: "0 0 21 19",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_8057_28323)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M9.75 0.5H2.75C2.28587 0.5 1.84075 0.679107 1.51256 0.997918C1.18437 1.31673 1 1.74913 1 2.2V15.8C1 16.2509 1.18437 16.6833 1.51256 17.0021C1.84075 17.3209 2.28587 17.5 2.75 17.5H13.25M9.75 0.5L15 5.6M9.75 0.5V5.6H15M15 5.6V10.7M11.5 9.85H4.5M11.5 13.25H4.5M6.25 6.45H4.5",
    stroke: "#150823",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16 18.5C18.2091 18.5 20 16.7091 20 14.5C20 12.2909 18.2091 10.5 16 10.5C13.7909 10.5 12 12.2909 12 14.5C12 16.7091 13.7909 18.5 16 18.5Z",
    fill: "#16CB79"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.6909 13.625L15.6284 15.7679L14.6909 14.7938",
    stroke: "white",
    strokeWidth: 0.8,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_8057_28323"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 21,
    height: 19,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInvoiceSelected);
export default __webpack_public_path__ + "static/media/invoice-selected.a84b536886108ca8e4bf12fb28f3abb3.svg";
export { ForwardRef as ReactComponent };